<lib-file-icon 
  [extensionType]="extensionType" 
  [file]="item?.file"
  [size]="size">
</lib-file-icon>
